import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import CTABtnModule from "../../modules/cta_btn_module";
import ContentModule from "../../modules/content_module";
import ImageModule from "../../modules/image_module";

import {RenderComponent} from "../../modules/render-component";

import "./Info.scss";

const Info = ({Module, GQLPage}) => {

    const renderComponent = RenderComponent()

    var imagename_large = "pages.home_tiles_component_image.large_tiles_image";

    let processedImages_large = JSON.stringify({});
    if (GQLPage?.imagetransforms?.home_tiles_component_image_Transforms) {
        processedImages_large = GQLPage?.imagetransforms?.home_tiles_component_image_Transforms;
    }

    var imagename_small = "pages.home_tiles_component_image.small_tiles_image";

    let processedImages_small = JSON.stringify({});
    if (GQLPage?.imagetransforms?.home_tiles_component_image_Transforms) {
        processedImages_small = GQLPage?.imagetransforms?.home_tiles_component_image_Transforms;
    }

    return (
        <React.Fragment>
            <section className={`info`}>
                <Container>
                    <Row>
                        <Col>
                            <div className="info-wrapper">
                                {Module?.home_tiles_block?.length > 0 && Module?.home_tiles_block?.map((item, index) =>{

                                    var className = "";
                                    var img_name = ""
                                    var img_processed = ""

                                    if(item.layout_type === "full_width"){
                                        className = "first-img";
                                        img_name = imagename_large;
                                        img_processed = processedImages_large
                                    }
                                    if(item.layout_type === "left_large_width"){
                                        className = "second-img";
                                        img_name = imagename_small;
                                        img_processed = processedImages_small
                                    }
                                    if(item.layout_type === "right_small_width"){
                                        className = "second";
                                        img_name = imagename_small;
                                        img_processed = processedImages_small
                                    }
                                    if(item.layout_type === "left_small_width"){
                                        className = "color-img";
                                        img_name = imagename_small;
                                        img_processed = processedImages_small
                                    }
                                    if(item.layout_type === "right_large_width"){
                                        className = "second-img";
                                        img_name = imagename_small;
                                        img_processed = processedImages_small
                                    }

                                    return(                                            
                                        <div className={`info-img ${className} ${item.content ? '' : "no_content"} ${item.layout_type}`}>
                                            {/* {item?.image?.url && <ImageModule ImageSrc={item.image} altText={item.title}/> } */}
                                            
                                            {item?.image?.url && renderComponent === "true" && 
                                                <ImageModule ImageSrc={item?.image} altText={item.title} imagetransforms={img_processed} ggfx_results={GQLPage?.ggfx_results} renderer="bgImg" imagename={img_name} strapi_id={GQLPage?.id} classNames="info_bg_img" />   
                                            }

                                            {item?.image?.url && <span className="transp_bg"></span> }
                                            
                                            <div className="info-content">
                                                <Container>
                                                    <Row>
                                                        <Col>
                                                            <h3>{item.title}</h3>

                                                            {item.content && <ContentModule Content={item.content}/>}

                                                            <CTABtnModule button_cta={item.button_cta} />

                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </div>
                                        </div>
                                    )
                                })}
                                
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>


        </React.Fragment>
    )
}
export default Info;
